<my-actor-avatar *ngIf="actor" [actor]="actor" actorType="account" [size]="size()"></my-actor-avatar>
